var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"ml-1",attrs:{"slot":"activator","flat":"","icon":""},on:{"click":function($event){return _vm.$emit('click')}},slot:"activator"},[_c('v-avatar',{staticClass:"bs avatar-bg",attrs:{"size":"32px"}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)],1),_c('span',[_vm._v(_vm._s(_vm.tip))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }